import React from 'react';
import { SubscriptionConfirmed } from '../../../common/subscription-confirmed/subscription-confirmed';

type Props = {}

export const BrandSubscriptionConfirmed = (props: Props) => {
  return (
    <SubscriptionConfirmed/>
  )
}